import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { typeIcons } from "./Utils";
import { useUserPermissions } from "../hooks/useUserPermissions";
import "./Navbar.css";
import logo from "../assets/financetalking.png";
import logoDark from "../assets/financetalking_dark.png";
import icon from "../assets/financetalking_icon.png";
import iconDark from "../assets/financetalking_icon_dark.png";

const Navbar = () => {
  const [isPinned, setIsPinned] = useState(false);
  const { permissions, loading, error } = useUserPermissions();

  const navbarHomeUrl = process.env.REACT_APP_SITE_URL || window.location.origin;

  // Load pin state from localStorage on component mount
  useEffect(() => {
    const savedPinState = localStorage.getItem('navbarPinned');
    if (savedPinState !== null) {
      setIsPinned(JSON.parse(savedPinState));
    }
  }, []);

  // Save pin state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('navbarPinned', JSON.stringify(isPinned));
  }, [isPinned]);

  const togglePin = () => {
    setIsPinned(!isPinned);
  };

  // Don't render navbar if permissions are still loading
  if (loading) {
    return null;
  }

  return (
    <div className={`navbar ${isPinned ? 'pinned' : ''}`}>
      <a
        href={navbarHomeUrl}
        className="nav-brand"
        title="Finance Talking"
      >
        <img
          src={icon}
          alt="Finance Talking"
          className="nav-brand-logo nav-logo-icon nav-logo-light"
        />
        <img
          src={iconDark}
          alt="Finance Talking"
          className="nav-brand-logo nav-logo-icon nav-logo-dark"
        />
        <img
          src={logo}
          alt="Finance Talking"
          className="nav-brand-logo nav-logo-full nav-logo-light"
        />
        <img
          src={logoDark}
          alt="Finance Talking"
          className="nav-brand-logo nav-logo-full nav-logo-dark"
        />
      </a>

      <div className="nav-divider nav-logo-divider"></div>

      <div className="nav-links">

        <NavLink to="/dashboard" className="nav-link">
          {typeIcons.dashboard}
          <span className="link-text">Dashboard</span>
        </NavLink>

        {/* Sessions link intentionally hidden */}
        {/* {permissions.can_view_sessions && (
          <NavLink to="/sessions" className="nav-link dimmed">
            {typeIcons.sessions}
            <span className="link-text">Sessions</span>
          </NavLink>
        )} */}

        {permissions.can_view_jobs && (
          <NavLink to="/jobs" className="nav-link">
            {typeIcons.jobs}
            <span className="link-text">Jobs</span>
          </NavLink>
        )}

        {(permissions.can_view_sessions || permissions.can_view_jobs || permissions.can_view_contacts || permissions.can_view_accounts || permissions.can_view_tasks || permissions.can_view_interactions) && (
          <div className="nav-divider"></div>
        )}

        {permissions.can_view_contacts && (
          <NavLink to="/contacts" className="nav-link">
            {typeIcons.contacts}
            <span className="link-text">Contacts</span>
          </NavLink>
        )}

        {permissions.can_view_accounts && (
          <NavLink to="/accounts" className="nav-link">
            {typeIcons.accounts}
            <span className="link-text">Accounts</span>
          </NavLink>
        )}

        {permissions.can_view_tasks && (
          <NavLink to="/tasks" className="nav-link">
            {typeIcons.tasks}
            <span className="link-text">Tasks</span>
          </NavLink>
        )}

        {permissions.can_view_interactions && (
          <NavLink to="/interactions" className="nav-link">
            {typeIcons.interactions}
            <span className="link-text">Interactions</span>
          </NavLink>
        )}

        {(permissions.can_view_slides || permissions.can_view_programme_builder || permissions.can_view_elearning) && (
          <div className="nav-divider"></div>
        )}

        {permissions.can_view_elearning && (
          <NavLink to="/elearning" className="nav-link">
            {typeIcons.elearning}
            <span className="link-text">eLearning</span>
          </NavLink>
        )}

        {permissions.can_view_slides && (
          <NavLink to="/slides" className="nav-link">
            {typeIcons.slides}
            <span className="link-text">Slide Manager</span>
          </NavLink>
        )}

        {permissions.can_view_programme_builder && (
          <NavLink to="/programmebuilder" className="nav-link">
            {typeIcons.programmebuilder}
            <span className="link-text">Builder</span>
          </NavLink>
        )}

        {permissions.can_view_handouts && (
          <NavLink to="/create-handouts" className="nav-link">
            {typeIcons.createhandouts}
            <span className="link-text">Create Handouts</span>
          </NavLink>
        )}

        {/*permissions.can_view_export && (
          <div className="nav-divider"></div>
        )*/}

        {/*permissions.can_view_export && (
          <NavLink to="/export" className="nav-link">
            {typeIcons.export}
            <span className="link-text">Export Data</span>
          </NavLink>
        )*/}

      </div>
      
      <NavLink to="/settings" className="nav-link">
        {typeIcons.settings}
        <span className="link-text">Settings</span>
      </NavLink>

      {/* Pin Button */}
      <button 
        className={`pin-button ${isPinned ? 'pinned' : ''}`}
        onClick={togglePin}
        title={isPinned ? 'Unpin navbar' : 'Pin navbar open'}
      >
        {typeIcons.pin}
        <span className="link-text">{isPinned ? 'Pinned' : 'Pin'}</span>
      </button>
    </div>
  );
};

export default Navbar;
